import { createSlice  } from '@reduxjs/toolkit';

export interface ModalStatusState {
    isShowModalStatus: boolean
    title: string
    msg?: string
    contentType: string
    icon?: string
  }

const  initialState :  ModalStatusState   = {
    isShowModalStatus: false,
    title: "test",
    msg: "test",
    contentType: "content",
    icon: "",
}

export const modalStatueSlice = createSlice({
    name : 'modalStatus',
    initialState,
    reducers : {
        showModaStatus : (state , action) => {
            const {payload} =action
            const { isShowModalStatus , title, contentType } = payload
             return {...state,
                isShowModalStatus: isShowModalStatus,
                title: title,
                contentType: contentType
            }
        },
        closeModalStatus : (state) =>  {
             state.isShowModalStatus = false
        } 


    }


}) //  end slice


export const {    showModaStatus , closeModalStatus } =   modalStatueSlice.actions;
export default  modalStatueSlice.reducer;